import {
    AbstractControl,
    UntypedFormControl,
    UntypedFormGroup,
    ValidationErrors,
    ValidatorFn,
    Validators,
} from '@angular/forms';

interface EqualsPasswordError {
    equalsPassword: boolean;
    equalsWithOldPassword: boolean;
}

export const equalsPasswordGroup = (passwordGroup: UntypedFormGroup): EqualsPasswordError | null => {
    const { oldPassword, newPassword, confirmPassword } = passwordGroup.getRawValue();
    const equalsPasswordError = {
        equalsWithOldPassword: oldPassword === newPassword,
        equalsPassword: newPassword !== confirmPassword,
    };
    return equalsPasswordError.equalsPassword || equalsPasswordError.equalsWithOldPassword ? equalsPasswordError : null;
};

export const landLinePattern = Validators.pattern(/^(?:(?:\+|00)33|0)[\s.\-,\/]?[1-5,8-9]((?:[\s.\-,\/]?\d{2}){4})$/);
export const mobilePattern = Validators.pattern(/^(?:(?:\+|00)33|0)[\s.\-,\/]?[6-7]((?:[\s.\-,\/]?\d{2}){4})$/);

/**
 * Group validator : au moins un des deux numéros de téléphone (fixe ou mobile) doit être renseigné.
 */
export const atLeastOnePhoneRequired =
    (firstPhoneControl: string, secondPhoneControl: string): ValidatorFn =>
    (phoneGroup: AbstractControl): ValidationErrors | null => {
        const firstValue = ((phoneGroup.get(firstPhoneControl)?.value as string) || '').trim();
        const secondValue = ((phoneGroup.get(secondPhoneControl)?.value as string) || '').trim();

        if (!firstValue && !secondValue) {
            return { atLeastOnePhoneRequired: true };
        }
        return null;
    };
// eslint-disable-next-line max-len
// Remove from portal front and use from portal lib
export const mailPattern = Validators.pattern(
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/
);

export const CODE_LENGTHS = {
    AD: 24,
    AE: 23,
    AT: 20,
    AZ: 28,
    BA: 20,
    BE: 16,
    BG: 22,
    BH: 22,
    BR: 29,
    CH: 21,
    CR: 21,
    CY: 28,
    CZ: 24,
    DE: 22,
    DK: 18,
    DO: 28,
    EE: 20,
    ES: 24,
    FI: 18,
    FO: 18,
    FR: 27,
    GB: 22,
    GI: 23,
    GL: 18,
    GR: 27,
    GT: 28,
    HR: 21,
    HU: 28,
    IE: 22,
    IL: 23,
    IS: 26,
    IT: 27,
    JO: 30,
    KW: 30,
    KZ: 20,
    LB: 28,
    LI: 21,
    LT: 20,
    LU: 20,
    LV: 21,
    MC: 27,
    MD: 24,
    ME: 22,
    MK: 19,
    MR: 27,
    MT: 31,
    MU: 30,
    NL: 18,
    NO: 15,
    PK: 24,
    PL: 28,
    PS: 29,
    PT: 25,
    QA: 29,
    RO: 24,
    RS: 22,
    SA: 24,
    SE: 24,
    SI: 19,
    SK: 24,
    SM: 27,
    TN: 24,
    TR: 26,
};

export const noWhitespaceValidator = (c: UntypedFormControl): object | null => {
    if (typeof c.value === 'object') {
        return null;
    }
    const isWhitespace = (c.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { required: true };
};
